// extracted by mini-css-extract-plugin
export default {"pageWrap":"Y-z","fullWidth":"Z-z","heading":"_-z","fullBleed":"aa-z","hidden":"ba-z"};